import { useEffect, useState } from 'react';

import { format } from 'date-fns';
import HtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';
import Transition from 'react-transition-group/Transition';

import { serviceTypes } from '../../store/initData/services';
import AccordionOption from '../AccordionOption/AccordionOption';
import Button from '../Button/Button';
import CloseButton from '../CloseButton/CloseButton';
import FormLabel from '../FormLabel/FormLabel';
import GeneralTile from '../GeneralTile/GeneralTile';
import './SelectOptionMap.scss';
import i18n from '../../i18n';

const animationDuration = 200;

export default function SelectOptionMap({
                                          onClose,
                                          options,
                                          open,
                                          selected,
                                          onNext,
                                          onSelect,
                                        }) {
  const generalTiles = useSelector((store) => store.data.generalTiles);
  const newIcons = useSelector((store) => store.data.newIcons);
  const currentService = useSelector((store) => store.state.service);
  const isWorkshopService = currentService.value === serviceTypes.workshop;
  const isSummerplayService = currentService.value === serviceTypes.summerplay;
  const isOneTimeWorkshopService = currentService.value === serviceTypes.one_time_workshop;
  const currentOccurrence = useSelector((store) => store.state.occurrence);
  const currentWorkshopPrice = useSelector((store) => store.state.robot?.price);
  const currentFranchise = useSelector((store) => store.state.city?.franchise);

  const getWorkshopTypeText = (o) => {
    if (o?.type === 0) {
      return i18n.t('selectOptionMap.summerplay');
    }
    if (o?.type === 1) {
      return i18n.t('selectOptionMap.holidayWorkshops');
    }
    if (o?.type === 2) {
      return i18n.t('selectOptionMap.workshops');
    }

    return i18n.t('selectOptionMap.notSetMasculine');
  };

  const workshopTypeText = getWorkshopTypeText(currentOccurrence);

  const shouldDisplayPrice =
    currentOccurrence?.payment_type !== 'kindergarden_vat_invoice';
  const shouldHideSignupCount = useSelector(
    (store) =>
      store.state.city.franchise.slug === 'poznan' &&
      (currentService.value === serviceTypes.summerplay ||
        currentService.value === serviceTypes.one_time_workshop),
  );

  const currentPrice = isWorkshopService
    ? currentWorkshopPrice
    : currentOccurrence?.all_week_price;

  const selectOptionMapTexts = useSelector(
    (store) => store.data.selectOptionMap,
  );
  const chooseText = useSelector((store) => store.data.chooseText);
  const warningMessage = selectOptionMapTexts.warning.replaceAll(
    '{email}',
    currentFranchise?.email || 'zapisy@g4r.pl',
  );

  const [enter, setEnter] = useState(false);

  const handleCloseButton = () => {
    setEnter(false);
    setTimeout(() => onClose(), 2 * animationDuration);
  };

  const containerStyles = {
    transition: `all ${animationDuration}ms ease-out`,
    position: 'absolute',
    overflow: 'hidden',
    bottom: 0,
    pointerEvents: 'auto',
    maxWidth: 700,
    width: '100%',
  };

  const transitionStyles = {
    entering: {
      maxHeight: '0px',
      minHeight: '0px',
    },
    entered: {
      maxHeight: '500px',
      minHeight: '500px',
    },
    exiting: {
      maxHeight: '500px',
      minHeight: '500px',
    },
    exited: {
      maxHeight: '0px',
      minHeight: '0px',
    },
  };

  useEffect(() => {
    open && setEnter(true);
  }, [open, options]);

  return (
    <Transition
      in={enter}
      timeout={{ appear: 0, enter: animationDuration, exit: animationDuration }}
    >
      {(state) => (
        <div style={{ ...containerStyles, ...transitionStyles[state] }}>
          <div className="SelectOptionMap-container">
            <div className="SelectOptionMap-wrapper">
              <div>
                <div className="SelectOptionMap-title-wrapper">
                  <div className="SelectOptionMap-formlabel-wrapper">
                    <FormLabel type={'big'} addStyle={{ marginTop: 10 }}>
                      {options[0]?.ws.location_title}
                    </FormLabel>
                  </div>
                  <div
                    className="SelectOptionMap-closebutton-wrapper"
                    style={{ alignSelf: 'flex-start', marginTop: 10 }}
                  >
                    <CloseButton onClose={handleCloseButton} />
                  </div>
                </div>
                <p className="SelectOptionMap-address">
                  {options[0]?.ws.physical_address}
                </p>
                <div className="SelectOptionMap-accordionoption-wrapper">
                  <AccordionOption
                    data={options}
                    selected={selected}
                    onClick={onSelect}
                    placeholder={selectOptionMapTexts.placeholder}
                    small
                    map
                  />
                </div>
                {currentOccurrence !== null && (
                  <div>
                    <div className="SelectOptionMap-generaltile-wrapper">
                      {isWorkshopService && !!currentOccurrence?.free_lesson_active &&(
                        <GeneralTile
                          key={0}
                          width={isSummerplayService ? '15%' : '20%'}
                          data={{
                            type: 2,
                            image: newIcons.coinFree,
                            title: currentOccurrence?.free_lesson_text
                              ? `${currentOccurrence?.free_lesson_text}`
                              : selectOptionMapTexts.defaults[0],
                            description: currentOccurrence?.free_lesson_description
                              ? `${currentOccurrence?.free_lesson_description}`
                              : selectOptionMapTexts.descriptions[0],
                          }}
                        />
                      )}
                      {!shouldHideSignupCount && (
                        <GeneralTile
                          key={1}
                          width={isSummerplayService ? '15%' : '20%'}
                          data={{
                            type: 2,
                            image: generalTiles[0].image,
                            title: currentOccurrence
                              ? 'Zapisanych: ' + currentOccurrence.signups
                              : selectOptionMapTexts.defaults[1],
                            description:
                              'Limit miejsc: ' + currentOccurrence.places_total,
                          }}
                        />
                      )}
                      <GeneralTile
                        key={2}
                        width={isSummerplayService ? '15%' : '20%'}
                        data={{
                          type: 2,
                          image: generalTiles[1].image,
                          title: currentOccurrence
                            ? `${convDate(
                              isWorkshopService,
                              currentOccurrence,
                              selectOptionMapTexts.errorInfo,
                            )}`
                            : selectOptionMapTexts.defaults[2],
                          description: isOneTimeWorkshopService ? i18n.t('selectOptionMap.term') : i18n.t('selectOptionMap.firstLesson'),
                        }}
                      />
                      {(isSummerplayService || isOneTimeWorkshopService) &&
                        currentOccurrence?.start_time &&
                        currentOccurrence?.end_time && (
                          <GeneralTile
                            key={6}
                            width={isSummerplayService ? '15%' : '20%'}
                            data={{
                              type: 2,
                              image: newIcons.hours,
                              title:
                                currentOccurrence?.start_time +
                                '-' +
                                currentOccurrence?.end_time,
                              description: isOneTimeWorkshopService ? 'Czas trwania' : selectOptionMapTexts.descriptions[6],
                            }}
                          />
                        )}
                      {((isWorkshopService && shouldDisplayPrice) ||
                        !isWorkshopService) && (
                        <GeneralTile
                          key={3}
                          width={isSummerplayService ? '15%' : '20%'}
                          data={{
                            type: 2,
                            image: newIcons.coinZl,
                            title: currentOccurrence?.special_price
                              ? `${currentOccurrence?.special_price}`
                              : currentPrice
                                ? `${currentPrice}`
                                : selectOptionMapTexts.defaults[3],
                            description: isOneTimeWorkshopService ? i18n.t('selectOptionMap.price') :
                              selectOptionMapTexts.descriptions[
                                isWorkshopService
                                  ? 3
                                  : 4 /* LOL, rework this later */
                                ],
                          }}
                        />
                      )}

                      {isSummerplayService && (
                        <GeneralTile
                          key={5}
                          width={isSummerplayService ? '15%' : '20%'}
                          data={{
                            type: 2,
                            image: generalTiles[0].image,
                            title: workshopTypeText,
                            description: selectOptionMapTexts.descriptions[5],
                          }}
                        />
                      )}
                    </div>
                    <div className="SelectOptionMap-description-wrapper">
                      <p className="SelectOptionMap-title">
                        {selectOptionMapTexts.title}
                      </p>
                      <p className="SelectOptionMap-description">
                        {HtmlParser(currentOccurrence.description || '')}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="SelectOptionMap-buttons-wrapper">
                {+selected?.ws.is_signup_allowed === 1 ? (
                  <div style={{display: 'flex',flexDirection: 'column', alignItems: 'center'}}>
                    <p className="SelectOptionMap--warning-text">
                      {+selected?.ws.allow_external_signups === 0
                        ? HtmlParser(
                          selectOptionMapTexts.onlyInternalSignups || '',
                        ) : ''
                      }
                    </p>
                    <Button type={'primary-bigger'} text={chooseText} onClick={onNext} />
                  </div>
                ) : selected ? (
                  <p className="SelectOptionMap--warning-text">
                    {+selected?.ws.allow_external_signups === 0
                      ? HtmlParser(
                        selectOptionMapTexts.onlyInternalSignups || '',
                      )
                      : selected?.ws.signup_disabled_text
                        ? HtmlParser(selected.ws.signup_disabled_text)
                        : HtmlParser(warningMessage)}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
}

const convDate = (isWorkshopService, currentOccurrence, info) => {
  const date = isWorkshopService
    ? currentOccurrence.show_lesson_time
    : currentOccurrence.start_date;

  if (date) {
    return format(
      new Date(date),
      isWorkshopService ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy',
    );
  } else {
    return info;
  }
};
